import { Input, type InputProps } from '@eika/input';
import { useSelectedChildEligibility } from '@hooks/context/use-account-application-context';
import { format } from '@translation-utils/use-translation';
import { useTranslation } from '@translations';
import { getApproverParentName } from '@utils/child-eligibility-utils';

type ApproverParentPhoneInputProps = Omit<InputProps, 'label'> & {
    label?: string;
};

export const ApproverParentPhoneInput = (props: ApproverParentPhoneInputProps) => {
    const { enterApproverParentInformation } = useTranslation();
    const childEligibility = useSelectedChildEligibility();

    if (!childEligibility) {
        return null;
    }

    return (
        <Input
            className="enter-approver-parent-information__form--input"
            label={format(enterApproverParentInformation.inputLabel, getApproverParentName(childEligibility))}
            type="tel"
            inputMode="tel"
            data-testid="approver-parent-phone-input"
            autoComplete="off"
            {...props}
        />
    );
};
